import type {
    AdminConsentRecordDecision,
    AdminConsentRecordSource,
    AdminConsentRecordType,
} from "src/api/client-api/consent/adminConsentRecord";
import type {
    ConsentGovernanceItem,
    ConsentGovernanceVersion,
} from "src/api/client-api/consent/useGetConsentGovernanceAdmin";

export const CONSENT_ADMIN_TAB_PARAM = "tab" as const;
export const DOCUMENTS_TAB = "documents" as const;
export const OPT_INS_TAB = "opt-ins" as const;
export const VERSIONS_TAB = "versions" as const;
export const RECORDS_TAB = "records" as const;

export const CONSENT_ADMIN_TAB_IDS = [DOCUMENTS_TAB, OPT_INS_TAB, VERSIONS_TAB, RECORDS_TAB] as const;

export type ConsentAdminTabId = (typeof CONSENT_ADMIN_TAB_IDS)[number];
export type ConsentGovernanceItemType = ConsentGovernanceItem["type"];

export type AdminConsentRecordDecisionFilter = "all" | AdminConsentRecordDecision;
export type AdminConsentRecordSourceFilter = "all" | AdminConsentRecordSource;
export type AdminConsentRecordTypeFilter = "all" | AdminConsentRecordType;

export type ConsentItemModalState = {
    consentItem?: ConsentGovernanceItem;
    itemType: ConsentGovernanceItemType;
    open: boolean;
};

export type ConsentItemVersionModalState = {
    consentItemType?: ConsentGovernanceItemType;
    consentVersion?: ConsentGovernanceVersion;
    open: boolean;
    preselectedConsentItem?: ConsentGovernanceItem;
};

export type ConsentCreationDrawerState = {
    initialType: ConsentGovernanceItemType;
    open: boolean;
};

export type ConsentPreviewDialogState = {
    item?: ConsentGovernanceItem;
    open: boolean;
    version?: ConsentGovernanceVersion;
};

export type ConsentDeleteTarget =
    | { kind: "item"; item: ConsentGovernanceItem }
    | { kind: "items"; items: ConsentGovernanceItem[] }
    | { kind: "version"; version: ConsentGovernanceVersion }
    | { kind: "versions"; versions: ConsentGovernanceVersion[] };

export type ConsentDeleteDialogState = {
    open: boolean;
    target?: ConsentDeleteTarget;
};
